// extracted by mini-css-extract-plugin
export default {"rootSearchIcon":"SearchIcon_rootSearchIcon__MgCQE"};